import { config } from '@/pageConfig/partners/us/en';
import { PartnersProgramPageTemplate } from '@/pageTemplate/PartnersProgramPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function PartnersProgramPage() {
  const { trackEvent } = useAnalyticsContext();
  useEffect(() => trackEvent('partners_page.viewed', { variant: 'default' }), [trackEvent]);

  return <PartnersProgramPageTemplate config={config} />;
}
